import React from "react";
import { User } from "ceicons";

import "./portionIconNumber.scss";
const PortionIconNumber = ({ portion }) => {
  return (
    <div className="portion-icon">
      {portion}
      <User />
    </div>
  );
};

export default PortionIconNumber;
